/**
 * Build a default form schema for new forms
 */
export const buildDefaultFormSchema = (title, description = "") => {
  const now = new Date().toISOString();
  return {
    title,
    description: description || "",
    created: now,
    smartChips: {},
    subsections: [],
    hiddenSubsections: [],
    settings: {
      submitButton: {
        text: "Submit",
        enabled: true,
      },
      confirmationMessage: "Thank you for your submission!",
      allowMultipleSubmissions: false,
    },
    metadata: {
      version: "1.0",
      lastModified: now,
      totalSubsections: 0,
    },
  };
};

